import React from 'react';

// Wave 20.4 — Logo redesigned to match the mobile brand.
//
// Renders as a bold "a.c" wordmark (aero.chat abbreviated) in the
// brand green (#6AFF45). Sized to the container props so it slots
// into the existing 200×104 header without layout shift.

interface Props {
  width: number;
  height: number;
  color?: string;
}

const Logo: React.FC<Props> = ({ width, height, color = '#6AFF45' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 104"
      width={width}
      height={height}
      preserveAspectRatio="xMidYMid meet"
      aria-label="aero.chat"
      role="img"
    >
      <text
        x="100"
        y="82"
        textAnchor="middle"
        fontFamily="Helvetica Neue, Helvetica, Arial, sans-serif"
        fontWeight="900"
        fontSize="88"
        fill={color}
        letterSpacing="-3"
      >
        a.c
      </text>
    </svg>
  );
};

export default Logo;
